exports.f = require('./_wks');



/*****************
 ** WEBPACK FOOTER
 ** ./~/semantic-ui-react/~/core-js/library/modules/_wks-ext.js
 ** module id = 341
 ** module chunks = 0
 **/